export default {
  PROMOTOR_REPOSITORY: Symbol.for('PROMOTOR_REPOSITORY'),
  SEARCH_PROMOTOR_QUERY: Symbol.for('SEARCH_PROMOTOR_QUERY'),
  PROMOTOR_STATE_MANAGER: Symbol.for('PROMOTOR_STATE_MANAGER'),
};
